<section>
  @if (showFilteredZeroState && (sessionListDataSource.isFiltered$ | async); as filtered) {
    <ngx-zero-state class="zero-state-filtered">
      <div zero-state-graphic>
        <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
      </div>
      <p zero-state-title [translate]="noVideosTitleKey"></p>
      @if (taskType === TaskType.React) {
        <p zero-state-subtext [innerHTML]="'session-zero-state_no-submissions-peer-subtext' | translate"></p>
      } @else {
        <p zero-state-subtext translate="session-zero-state_no-videos-change-filters-subtext"></p>
      }
    </ngx-zero-state>
  } @else {
    @if (learnFromFeedbackState) {
      @let learnFromFeedbackStateContent = learnFromFeedbackContent[learnFromFeedbackState];
      <ngx-zero-state class="zero-state-no-video">
        <div zero-state-graphic>
          <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
        </div>
        <p zero-state-title [translate]="learnFromFeedbackStateContent?.title"></p>
        <p zero-state-subtext [innerHTML]="(learnFromFeedbackStateContent?.subtext ?? '') | translate"></p>
      </ngx-zero-state>
    } @else {
      @switch (getZeroStateStatus()) {
        @case (zeroStates.BATCH_CREATE_SESSION) {
          <ngx-zero-state class="zero-state-live">
            <div zero-state-graphic>
              <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
            </div>
            <p zero-state-title [translate]="getLiveReviewTitleTranslationKey()"></p>
					<p zero-state-subtext [innerHTML]="
						'session-zero-state_live-review-subtext' | translate:{
							activityName: getActivityName()
						}">
            </p>
            <div zero-state-body>
              <button
                class="btn secondary-btn create-videos-btn"
                translate="activity-view_create-videos"
                [disabled]="(canStartActivity$$ | async) === false"
                disabledInteractive
                [matTooltip]="getSessionCreationDisabledMessage$$ | async"
                [matTooltipDisabled]="canStartActivity$$ | async"
                matTooltipPosition="above"
                (click)="createBatchSessions()">
              </button>
              <button
                class="btn secondary-btn start-activity-btn"
                translate="session-zero-state_start-activity"
                data-cy="add-video"
                (click)="startActivityIfAllowed()"
                [disabled]="(canStartActivity$$ | async) === false"
                disabledInteractive
                [matTooltip]="getSessionCreationDisabledMessage$$ | async"
                [matTooltipDisabled]="canStartActivity$$ | async"
                matTooltipPosition="above">
              </button>
            </div>
          </ngx-zero-state>
        }
        @case (zeroStates.NO_VIDEOS) {
          <ngx-zero-state class="zero-state-no-video">
            <div zero-state-graphic>
              <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
            </div>
            <p zero-state-title [translate]="noVideosTitleKey"></p>
            <p zero-state-subtext [innerHTML]="noVideosSubtextKey | translate: noVideosSubtextParams"></p>
            <div zero-state-body>
              @if (showInviteButton) {
                <button
                  type="button"
                  class="btn invite-learners-btn"
                  [class.primary-btn]="!showCreateVideoButton"
                  [class.secondary-btn]="showCreateVideoButton"
                  translate="activity-report_invite-learners"
                  data-cy="invite-learners-primary"
                  (click)="inviteLearners.emit()">
                </button>
              }
              @if (showCreateVideoButton) {
                <span
                  [tabindex]="(canStartActivity$$ | async) ? -1 : 0"
                  [matTooltip]="getSessionCreationDisabledMessage$$ | async"
                  [matTooltipDisabled]="canStartActivity$$ | async"
                  [attr.aria-disabled]="(canStartActivity$$ | async) === false"
                  matTooltipPosition="above">
                  <button
                    type="button"
                    class="btn primary-btn start-activity-btn create-video-btn"
                    translate="activity-view_create-video"
                    data-cy="add-video"
                    [attr.aria-label]="'activity-view_create-a-video' | translate"
                    (click)="startActivity.emit()"
                    [disabled]="(canStartActivity$$ | async) === false"
                    [attr.aria-hidden]="(canStartActivity$$ | async) === false">
                  </button>
                </span>
              }
              @if (!showCreateVideoButton && !showInviteButton) {
                <button
                  class="link-btn view-instructions-btn" href="#"
                  data-cy="view-instructions"
                  (click)="viewInstructions.emit()"
                  translate="session-zero-state_view_instructions">
                </button>
                <button
                  class="btn secondary-btn start-activity-btn"
                  translate="session-zero-state_start-activity"
                  data-cy="add-video"
                  (click)="startActivityIfAllowed()"
                  [disabled]="(canStartActivity$$ | async) === false"
                  disabledInteractive
                  [matTooltip]="getSessionCreationDisabledMessage$$ | async"
                  [matTooltipDisabled]="canStartActivity$$ | async"
                  matTooltipPosition="above">
                </button>
              }
            </div>
          </ngx-zero-state>
        }
        @case (zeroStates.START_ACTIVITY) {
          <ngx-zero-state class="zero-state-start-activity">
            <div zero-state-graphic>
              <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
            </div>
            <p zero-state-title [translate]="getTitleTranslationKey()"></p>
            <p zero-state-subtext [translate]="getSubtextTranslationKey()"></p>
            <div zero-state-body>
              @if (!isActivityTasksEnabled) {
                <button
                  class="link-btn view-instructions-btn" href="#"
                  data-cy="view-instructions"
                  (click)="viewInstructions.emit()"
                  translate="session-zero-state_view_instructions">
                </button>
              }
              <button
                class="btn primary-btn start-activity-btn"
                [translate]="getButtonTranslationKey()"
                data-cy="add-video"
                (click)="startActivityIfAllowed()"
                [disabled]="(canStartActivity$$ | async) === false"
                disabledInteractive
                [matTooltip]="getSessionCreationDisabledMessage$$ | async"
                [matTooltipDisabled]="canStartActivity$$ | async"
                matTooltipPosition="above">
              </button>
            </div>
          </ngx-zero-state>
        }
      }
    }
  }
</section>
